import { Trash } from "@phosphor-icons/react";

export const AdjustmentTable = ({ list, month, onDelete }) => (
  <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto" data-testid="adjustments-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wide text-stone-500 border-b border-stone-200">
          <th className="px-5 py-4">Employee</th>
          <th className="px-5 py-4">Type</th>
          <th className="px-5 py-4">Label</th>
          <th className="px-5 py-4 text-right">Amount</th>
          <th className="px-5 py-4"></th>
        </tr>
      </thead>
      <tbody className="divide-y divide-stone-100">
        {list.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-stone-400">No adjustments for {month} yet.</td></tr>}
        {list.map((a) => (
          <tr key={a.id}>
            <td className="px-5 py-3"><span className="font-semibold">{a.employee_name}</span><div className="text-xs text-stone-500">{a.employee_code}</div></td>
            <td className="px-5 py-3">
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${a.type === "reimbursement" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>
                {a.type === "reimbursement" ? "Reimbursement" : "Deduction"}
              </span>
            </td>
            <td className="px-5 py-3">{a.label}</td>
            <td className="px-5 py-3 text-right tabular-nums font-semibold">₹{a.amount.toLocaleString("en-IN")}</td>
            <td className="px-5 py-3 text-right">
              <button onClick={() => onDelete(a.id)} data-testid={`delete-adjustment-${a.id}`}
                className="text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={16} /></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
